import React, { FC, useState } from 'react'

import classNames from 'classnames'
import { Link, To } from 'react-router-dom'

import { CollectionCollectionItem } from '@models/CollectionItem'
import PageRoutes from '@utils/page-routes'

interface CollectionCardProps {
  item: CollectionCollectionItem
}

export const CollectionCard: FC<CollectionCardProps> = ({
  item,
  ...props
}: CollectionCardProps): JSX.Element => {
  const [imgLoaded, setImgLoaded] = useState(false)
  const linkTo: To = {
    pathname: PageRoutes.musicSearchPath(),
    search: item.query ?? '',
  }

  return (
    <Link
      to={linkTo}
      className="inline-block w-full mx-2.5 bg-cover max-w-full md:max-w-[345px] h-[230px] rounded-md overflow-hidden relative"
      {...props}>
      <img
        alt={item.name}
        src={`/client/1.0/collection_image/${item.collection_image_id}`}
        onLoad={() => setImgLoaded(true)}
        className={classNames(
          'h-full object-cover transition-opacity',
          imgLoaded ? 'opacity-100' : 'opacity-0'
        )}
      />
      <div
        className={classNames(
          'absolute inset-0',
          imgLoaded ? 'bg-gradient' : 'bg-white dark:bg-black-bg2'
        )}
      />
      <h3
        className={classNames(
          'p-5 text-xl font-medium absolute top-0 left-0',
          imgLoaded ? 'text-white' : 'text-black'
        )}>
        {item.name}
      </h3>
    </Link>
  )
}
